<form [formGroup]="dynamicForm" (keydown.enter)="$event.preventDefault()">
  <div
    class="fdx-o-grid__row fdx-o-grid__row--center fdx-o-grid__row--guttered-medium"
    formArrayName="rows">
    <div
      class="fdx-o-grid__item--11 fdx-o-grid__item--12@medium"
      *ngFor="let row of rows.controls; let i = index"
      [formGroupName]="i">
      <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small">
        <div
          class="fdx-o-grid__item--11 fdx-o-grid__row fdx-o-grid__row--guttered-medium-y-small">
          <app-form-input-control
            class="fdx-o-grid__item--2"
            [formField]="row.get('parcel_count')"
            [labelName]="'Liczba'"
            [suffix]="'szt'">
            <input
              type="number"
              class="fdx-c-form-group__input fdx-u-px--0 fdx-u-px--4@medium"
              [id]="'parcel_count_' + i"
              formControlName="parcel_count"
              min="0"
              (input)="
                this.formService.onInputForNumberField2(
                  $event,
                  row.get('parcel_count')
                )
              " />
          </app-form-input-control>

          <app-form-input-control
            class="fdx-o-grid__item--2"
            [formField]="row.get('parcel_weight')"
            [labelName]="'Waga'"
            [suffix]="'kg'">
            <input
              type="number"
              class="fdx-c-form-group__input fdx-u-px--0 fdx-u-px--4@medium"
              [id]="'parcel_weight_' + i"
              formControlName="parcel_weight"
              min="0"
              (input)="
                this.formService.onInputForNumberField2(
                  $event,
                  row.get('parcel_weight')
                )
              " />
          </app-form-input-control>

          <app-form-input-control
            class="fdx-o-grid__item--2"
            [formField]="row.get('parcel_length')"
            [labelName]="'Długość'"
            [suffix]="'cm'">
            <input
              type="number"
              class="fdx-c-form-group__input fdx-u-px--0 fdx-u-px--4@medium"
              [id]="'parcel_length_' + i"
              formControlName="parcel_length"
              min="0"
              (input)="
                this.formService.onInputForNumberField2(
                  $event,
                  row.get('parcel_length')
                )
              " />
          </app-form-input-control>

          <app-form-input-control
            class="fdx-o-grid__item--2"
            [formField]="row.get('parcel_width')"
            [labelName]="'Szerokość'"
            [suffix]="'cm'">
            <input
              type="number"
              class="fdx-c-form-group__input fdx-u-px--0 fdx-u-px--4@medium"
              [id]="'parcel_width_' + i"
              formControlName="parcel_width"
              min="0"
              (input)="
                this.formService.onInputForNumberField2(
                  $event,
                  row.get('parcel_width')
                )
              " />
          </app-form-input-control>

          <app-form-input-control
            class="fdx-o-grid__item--2"
            [formField]="row.get('parcel_height')"
            [labelName]="'Wysokość'"
            [suffix]="'cm'">
            <input
              type="number"
              class="fdx-c-form-group__input fdx-u-px--0 fdx-u-px--4@medium"
              [id]="'parcel_height_' + i"
              formControlName="parcel_height"
              min="0"
              (input)="
                this.formService.onInputForNumberField2(
                  $event,
                  row.get('parcel_height')
                )
              " />
          </app-form-input-control>

          <div class="fdx-o-grid__item--2 fdx-o-grid__item--center">
            <div class="fdx-c-form fdx-c-form--checkbox">
              <label
                [for]="'parcel_not_standard_' + i"
                class="fdx-c-form__label"
                style="padding-left: 30px"
                >Element niestandardowy</label
              >
              <input
                type="checkbox"
                name="format"
                class="fdx-c-form__checkbox"
                [id]="'parcel_not_standard_' + i"
                formControlName="parcel_not_standard" />
              <div class="fdx-c-form__indicator"></div>
            </div>
          </div>
        </div>
        <div
          class="fdx-o-grid__item--1 fdx-o-grid__item--center fdx-u-align--center"
          [hidden]="i === 0">
          <button
            (click)="removeRow(i)"
            class="fdx-c-button fdx-c-button--square fdx-u-border--none fdx-u-bg-color--white fdx-u-color--blue">
            <div class="fdx-c-button__icon" aria-hidden="true">
              <svg
                class="fdx-c-icon"
                version="1.1"
                id="Icons"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
                enable-background="new 0 0 24 24"
                xml:space="preserve">
                <g>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="none"
                    stroke="#007AB7"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    d="M20,5H4 v15.5C4,22,5,23,6.5,23h11c1.5,0,2.5-1,2.5-2.5V5z" />
                  <line
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="none"
                    stroke="#007AB7"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    x1="9"
                    y1="9"
                    x2="9"
                    y2="19" />
                  <line
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="none"
                    stroke="#007AB7"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    x1="15"
                    y1="9"
                    x2="15"
                    y2="19" />
                  <line
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="none"
                    stroke="#007AB7"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    x1="2"
                    y1="5"
                    x2="22"
                    y2="5" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="none"
                    stroke="#007AB7"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    d="M16,5V2 c0-0.7-0.5-1-1-1H8.8C8.3,1,8,1.3,8,2v3H16z" />
                </g>
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small fdx-u-mb--5">
    <button
      href="#"
      class="fdx-c-button fdx-c-button--text"
      (click)="addRow()"
      [disabled]="rows.length >= 20">
      <div class="fdx-c-button__icon" aria-hidden="true">
        <svg
          class="fdx-c-icon"
          aria-hidden="true"
          focusable="false"
          role="presentation">
          <use xlink:href="#navigational_card_view"></use>
        </svg>
      </div>
      <span class="fdx-c-button__title">DODAJ PALETĘ</span>
    </button>
  </div>

  <div class="fdx-o-grid__row fdx-o-grid__row--center">
    <div class="fdx-o-grid__item--11">
      <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small">
        <div class="fdx-o-grid__item--12">
          <div class="fdx-c-form fdx-c-form--checkbox fdx-u-mb--2">
            <label
              for="parcel_is_cod"
              class="fdx-c-form__label"
              style="padding-left: 30px"
              >Pobranie</label
            >
            <input
              type="checkbox"
              name="format"
              class="fdx-c-form__checkbox"
              id="parcel_is_cod"
              formControlName="parcel_is_cod" />

            <div class="fdx-c-form__indicator"></div>
          </div>
        </div>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="dynamicForm.get('parcel_cod_amount')"
          [labelName]="'Kwota pobrania'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="parcel_cod_amount"
            formControlName="parcel_cod_amount"
            (input)="this.formService.formatAmount($event)" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="dynamicForm.get('parcel_account_number')"
          [labelName]="'Numer konta'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="parcel_account_number"
            formControlName="parcel_account_number"
            (input)="
              this.formService.onInputForNumberField2(
                $event,
                parcelAccountNumber
              )
            " />
        </app-form-input-control>

        <div class="fdx-o-grid__item--12 fdx-u-mt--3">
          <div class="fdx-c-form fdx-c-form--checkbox fdx-u-mb--2">
            <label
              for="parcel_is_insurance"
              class="fdx-c-form__label"
              style="padding-left: 30px"
              >Ubezpieczenie</label
            >
            <input
              type="checkbox"
              name="format"
              class="fdx-c-form__checkbox"
              id="parcel_is_insurance"
              formControlName="parcel_is_insurance" />
            <div class="fdx-c-form__indicator"></div>
          </div>
        </div>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="dynamicForm.get('parcel_insurance_amount')"
          [labelName]="'Kwota ubezpieczenia'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="parcel_insurance_amount"
            formControlName="parcel_insurance_amount"
            (input)="this.formService.formatAmount($event)" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="dynamicForm.get('parcel_content')"
          [labelName]="'Zawartość przesyłki'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="parcel_content"
            formControlName="parcel_content" />
        </app-form-input-control>
      </div>
    </div>
  </div>

  <app-form-error-message
    [submitException]="submitException()"
    [form]="dynamicForm">
  </app-form-error-message>

  @if (rows.invalid) { @if (rows.errors?.['MAX_SUM_PARCEL_COUNT']) {
  <div
    class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-color--error fdx-u-mt--5 fdx-u-mb--5">
    <p class="fdx-u-font-size--small fdx-u-align--center">
      Przekroczono maksymalną liczbę elementów na liście. <br />
      Dopuszczalny limit to 20 palet. <br />
    </p>
  </div>
  } }

  <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--5">
    <app-back-button
      [isLoading]="false"
      [isDisabled]="isSubmitLoading()"
      [buttonText]="'WSTECZ'"
      (clickEvent)="backButtonAction()">
    </app-back-button>
    <app-submit-button
      [isLoading]="isSubmitLoading()"
      [isDisabled]="dynamicForm.invalid"
      [buttonText]="'DALEJ'"
      (clickEvent)="onSubmit()"
      style="margin-left: 5px; margin-right: 2.5px">
    </app-submit-button>
  </div>
</form>
